import { render, staticRenderFns } from "./rejectedModal.vue?vue&type=template&id=b1635968"
import script from "./rejectedModal.vue?vue&type=script&lang=js"
export * from "./rejectedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports